<template>
  <div id="aboutBlissMall">

    <mt-header title="关于我们" style="height: 50px">
      <router-link to="/mine" slot="left">
        <mt-button>
          <img src="../../../assets/icon/back.png" height="auto" width="8px" slot="icon" style="margin-left: 12px">
        </mt-button>
      </router-link>
    </mt-header>
    <hr style="height: 1px;background-color: #d8d8d8;"/>

    <p id="aboutBlissMall-content-detail">
      &nbsp&nbsp&nbsp&nbsp&nbsp深圳市幸福商城科技股份有限公司 （以下简称幸福商城）2008年创立于深圳，凭借健康的食材和人性化的服务，幸福商城在各界普受好评。幸福商城微信公众号现今拥有百万粉丝，已成为国内知名O2O电商蛋糕品牌。集研发生产销售于一体，幸福商城始终坚持“百分百新鲜制作”，为消费者生产健康、安全、绿色的五星级烘焙食品。8年来，幸福商城以“用心、传递幸福”的企业使命不断超越自我，完善服务，给成千上万的粉丝带去幸福的味道。<br />
      &nbsp&nbsp&nbsp&nbsp&nbsp自2015年8月以来，先后开发数十个一二线城市，包括深圳、上海、北京、广州、海口、武汉、广州等。用户可在微信服务号（幸福商城）下单，配送时长2-5小时，部分地区有1小时专车。
    </p>

    <div id="aboutBlissMall-footer">
      <div class="aboutBlissMall-foot-cell">
        <img src="../../../assets/icon/map.png" class="aboutBlissMall-cell-img"/>
        <span class="aboutBlissMall-cell-title">总部地址</span>
        <span class="aboutBlissMall-cell-detail">深圳市龙岗区布龙路339号鸿生源工业区A栋5层</span>
      </div>

      <div class="aboutBlissMall-foot-cell">
        <img src="../../../assets/icon/phone.png" class="aboutBlissMall-cell-img"/>
        <span class="aboutBlissMall-cell-title">电话</span>
        <span class="aboutBlissMall-cell-detail">400-999-6666</span>
      </div>

      <div class="aboutBlissMall-foot-cell">
        <img src="../../../assets/icon/weibo.png" class="aboutBlissMall-cell-img"/>
        <span class="aboutBlissMall-cell-title">微博</span>
        <span class="aboutBlissMall-cell-detail">幸福西饼BLISSCAKE</span>
      </div>

      <div class="aboutBlissMall-foot-cell">
        <img src="../../../assets/icon/weixin.png" class="aboutBlissMall-cell-img"/>
        <span class="aboutBlissMall-cell-title">微信账号</span>
        <span class="aboutBlissMall-cell-detail">幸福西饼</span>
      </div>

      <div class="aboutBlissMall-foot-cell">
        <img src="../../../assets/icon/email.png" class="aboutBlissMall-cell-img"/>
        <span class="aboutBlissMall-cell-title">投诉/建议邮箱</span>
        <span class="aboutBlissMall-cell-detail">ceo@blissmall.net</span>
      </div>
    </div>

  </div>
</template>

<script>

  export default {
    name: 'aboutBlissMall',
    mounted () {
    },
    destroyed () {
    },
    computed: {

    }
  }
</script>



<style lang="scss">
  @import '../../../assets/css/mixin';


  #aboutBlissMall-content-detail {
    margin-top: pxToRem(54px);
    margin-left: pxToRem(60px);
    margin-right: pxToRem(60px);
    font-size: pxToRem(24px);
    line-height: pxToRem(56px);
  }

  #aboutBlissMall-footer {
    margin-top: pxToRem(118px);
    margin-left: pxToRem(60px);
    margin-right: pxToRem(60px);
    margin-bottom: 50px;
  }

  .aboutBlissMall-foot-cell {
    display: block;
    /*height: pxToRem(26px);*/
    /*line-height: pxToRem(26px);*/
    margin-top: pxToRem(28px);
    /*background-color: #4caf50;*/
  }

  .aboutBlissMall-cell-img {
    width: pxToRem(28px);
    height:auto;
    vertical-align: middle;
  }

  .aboutBlissMall-cell-title {
    margin-left: pxToRem(16px);
    font-size: pxToRem(20px);
    color: #666666;
    width: pxToRem(140px);
    vertical-align: middle;
    display:inline-block;
  }

  .aboutBlissMall-cell-detail {
    vertical-align: middle;
    font-size: pxToRem(20px);
    color: #191919;
    display:inline-block;
    width: pxToRem(424px);
  }

  /*.aboutBlissMall-cell-content {*/
    /*display: inline-block;*/
  /*}*/
</style>


// WEBPACK FOOTER //
// aboutBlissMall.vue?3b1a5668